module.exports = __webpack_public_path__ + "static/media/align-center-vertical.c67f137f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/icons/align-center-vertical.svg
// module id = 2263
// module chunks = 7